/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Faq_A5Inputs */

const en_minifier_faq_a5 = /** @type {(inputs: Minifier_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usually not worth a build step. Gzip removes repeated whitespace very efficiently, so on a measured sample minification only cut a further 10.3 percent after compression. Minify when bytes are counted uncompressed, such as in a database column or localStorage.`)
};

const ko_minifier_faq_a5 = /** @type {(inputs: Minifier_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빌드 단계를 들일 만한 가치는 보통 없습니다. gzip이 반복 공백을 아주 효율적으로 제거하므로, 실측 표본에서 압축은 gzip 이후 10.3퍼센트만 더 줄였습니다. 데이터베이스 컬럼이나 localStorage처럼 바이트가 압축되지 않은 상태로 계산될 때 압축하세요.`)
};

const ja_minifier_faq_a5 = /** @type {(inputs: Minifier_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビルド段階を用意するほどの価値は通常ありません。gzip が繰り返しの空白をきわめて効率よく取り除くため、実測サンプルでは圧縮は gzip 後にさらに 10.3 パーセントしか削れませんでした。データベース列や localStorage のようにバイトが未圧縮で数えられるときに圧縮してください。`)
};

/**
* | output |
* | --- |
* | "Usually not worth a build step. Gzip removes repeated whitespace very efficiently, so on a measured sample minification only cut a further 10.3 percent after..." |
*
* @param {Minifier_Faq_A5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_faq_a5 = /** @type {((inputs?: Minifier_Faq_A5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Faq_A5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_faq_a5(inputs)
	if (locale === "ko") return ko_minifier_faq_a5(inputs)
	return ja_minifier_faq_a5(inputs)
});